/** Kategori produk default — bisa diedit di Admin → Kategori Produk */
export const DEFAULT_PRODUCT_CATEGORIES = [
  { id: 'kopi', label: 'Kopi' },
  { id: 'teh', label: 'Teh' },
  { id: 'cokelat', label: 'Cokelat' },
  { id: 'buah', label: 'Buah-buahan' },
  { id: 'milkshake', label: 'Milkshake' },
];

export function getProductCategories(settings) {
  const saved = settings?.page_builder?.product_categories;
  if (Array.isArray(saved) && saved.length > 0) {
    return saved
      .filter((c) => c && c.id && c.id !== 'all' && c.label)
      .map((c) => ({ id: String(c.id).trim(), label: String(c.label).trim() }));
  }
  return DEFAULT_PRODUCT_CATEGORIES;
}

/** Filter chips di halaman Produk (selalu ada "Semua") */
export function getProductCategoryFilters(settings) {
  return [{ id: 'all', label: 'Semua' }, ...getProductCategories(settings)];
}

export function slugifyCategoryId(label) {
  return String(label || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || `cat-${Date.now().toString(36)}`;
}
